module.exports = __webpack_public_path__ + "media/images/jasper-signature-a776902baae2161f24c5d085560356f2.png";